import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import {
  initialValues,
  validationSchema,
} from "../../../componentes/Conductor_EditarPerfil";
import { Segment, Grid, Header } from "semantic-ui-react";
import "../../../scss/index.scss";
import { estiloSegmento } from "../../../estilos/segmentos";
import { estiloColores } from "../../../estilos/colores";
import Swal from "sweetalert2";
import {
  cambios_registrados_correctamente,
  error_al_guardar_cambios,
  email,
  banco,
  nombre_Banco,
  titular,
  selecciona_idioma,
} from "../../../utils/traductor";
import { apiIdioma } from "../../../api/idioma";
import { apiLocalidad } from "../../../api/localidad";
import { apiUsuario } from "../../../api/usuario";
import {
  editar_perfil,
  nombre,
  apellido,
  idioma,
  localidad,
  contacto,
  telefono,
  general,
} from "../../../utils/traductor";
import { ENTORNO } from "../../../utils/constantes";
import {
  setTitulo,
  getrole,
  setemail,
  setNombre,
  setApellido,
  setIdioma,
  setTelefono,
  setLocalidad,
  setContactosEmergencia,
  setavatar,
  setNombrebanco,
  setTitular,
  setCBU,
  getid,
} from "../../../utils/variablesLocales";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import HomeIcon from "@mui/icons-material/Home";
import { TextField } from "@material-ui/core";
import FormControl from "@mui/material/FormControl";
import NativeSelect from "@mui/material/NativeSelect";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import animacion from "../../../imagenes/AnimacionesVarias/LoadingMap.json";
import { Player } from "@lottiefiles/react-lottie-player";

function ScrollTop(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({
        block: "center",
      });
    }
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{ position: "fixed", bottom: 16, right: 16 }}
      >
        {children}
      </Box>
    </Fade>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

const apiidioma = new apiIdioma();
const apilocalidad = new apiLocalidad();
const apiusuario = new apiUsuario();

export function EditarPerfil(props) {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const Titulo = editar_perfil;
  setTitulo(Titulo);

  ////////////////////////////////

  const [idiomas, setIdioma1] =
    useState(
      null
    ); /*esta variable idiomas, maneja el estado del item seleccionado en el combo idioma*/

  const [localidades, setLocalidad1] =
    useState(
      null
    ); /*esta variable localidades, maneja el estado del item seleccionado en el combo localidad*/

  const [yaCargo, setyaCargo] = useState(false);

  ////////////////////////////////

  const navigate = useNavigate();

  const [SistemaOperativo, setSistemaOperativo] = useState("");

  /*este es como el load de asp.net*/
  useEffect(() => {
    (async () => {
      try {
        //controlando la seguridad para que solo acceda a esta pantalla el perfil que corresponda
        if (getrole() !== "Conductor") {
          navigate(ENTORNO.URL_APLICACION + "/CerrarSesion");
        }
        ///////////////////////////////////////////////////////

        ////////////////////////////////////
        //detectar sistema operativo
        const userAgent = navigator.userAgent.toLowerCase();
        setSistemaOperativo(userAgent);
        ////////////////////////////////////

        if (!yaCargo) {
          setyaCargo(true);
          //obtengo la lista de idiomas para luego cargar el combo
          const respuesta = await apiidioma.obtener();
          setIdioma1(respuesta);

          //obtengo la lista de localidades para luego cargar el combo
          const respuesta1 = await apilocalidad.obtener();
          setLocalidad1(respuesta1);
        }

        document.body.style.zoom = "100%";
      } catch (error) {
        console.error(error);
      }
    })();
  });

  ////////////////////////////////

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        //guardar cambios
        setemail(formik.values.email);
        setNombre(formik.values.nombre);
        setApellido(formik.values.apellido);
        setTelefono(formik.values.telefono);
        setIdioma(formik.values.idioma);
        setLocalidad(formik.values.localidad);
        // setContactosEmergencia(formik.values.contactosemergencia);
        // setavatar(formik.values.avatar.replace("uploads/", ""));
        setNombrebanco(formik.values.nombreBanco);
        setTitular(formik.values.titular);
        setCBU(formik.values.CBU);

        const respuesta = await apiusuario.actualizarAvatarConductor(
          formik.values.nombre,
          formik.values.apellido,
          formik.values.idioma,
          formik.values.localidad,
          // formik.values.localidad,
          formik.values.email,
          formik.values.telefono,
          // formik.values.fileAvatar,
          // formik.values.contactosemergencia,
          formik.values.nombreBanco,
          formik.values.titular,
          formik.values.CBU
        );

        if (respuesta.status === 200) {
          Swal.fire({
            title: "",
            text: cambios_registrados_correctamente,
            icon: "success",
            confirmButtonText: "Ok",
            confirmButtonColor: estiloColores.Azul,
          }).then(function () {
            //muestro back-drop
            setOpen(true);

            window.location.reload(true);
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: error_al_guardar_cambios,
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: estiloColores.Gris,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
  });

  ////////////////////////////////

  var idiomaRegistros = [];

  if (idiomas) {
    for (let i = 0; i < idiomas.length; i++) {
      idiomaRegistros.push({
        key: idiomas[i].Nombre,
        text: idiomas[i].Nombre,
        value: idiomas[i].Nombre,
      });
    }
  }
  ////////////////////////////////

  var localidadRegistros = [];

  const navigateToInicio = async () => {
    navigate(ENTORNO.URL_APLICACION + "/Conductor/Inicio");
  };

  if (localidades) {
    for (let i = 0; i < localidades.length; i++) {
      localidadRegistros.push({
        key: localidades[i].Nombre,
        text: localidades[i].Nombre,
        value: localidades[i].Nombre,
      });
    }
  }

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div
      style={{
        overflow: "hidden",
        touchAction: "manipulation",
        msTouchAction: "manipulation",
      }}
    >
      <form onSubmit={formik.handleSubmit}>
        <React.Fragment>
          <CssBaseline />
          <AppBar style={{ background: "#DC030E" }}>
            <Toolbar>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                onClick={navigateToInicio}
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <HomeIcon />
              </IconButton>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                {editar_perfil}
              </Typography>
              <IconButton
                size="large"
                aria-label="display more actions"
                edge="end"
                color="inherit"
                type="submit"
              >
                <CheckIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
          <Toolbar id="back-to-top-anchor" />
          <Container>
            <Box sx={{ my: 2 }}>
              <Segment style={estiloSegmento.Pasajero}>
                <Grid
                  textalign="center"
                  container
                  style={{ padding: "1em 0em" }}
                >
                  <div className="ingresar">
                    <Grid.Row>
                      <Grid.Column style={{ maxWidth: 450 }}>
                        <Box
                          //component="form"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            "& > :not(style)": { m: 1, width: "100%" },
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          {/* <Header as="h3">{general}</Header> */}
                          <TextField
                            id="nombre"
                            label={nombre}
                            placeholder={nombre}
                            variant="standard"
                            name="nombre"
                            type="text"
                            value={formik.values.nombre}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.nombre &&
                              Boolean(formik.errors.nombre)
                            }
                            helperText={
                              formik.touched.nombre && formik.errors.nombre
                            }
                            style={{ margin: "none" }}
                            size="small"
                          />
                          <TextField
                            id="apellido"
                            label={apellido}
                            placeholder={apellido}
                            variant="standard"
                            name="apellido"
                            type="text"
                            value={formik.values.apellido}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.apellido &&
                              Boolean(formik.errors.apellido)
                            }
                            helperText={
                              formik.touched.apellido && formik.errors.apellido
                            }
                            size="small"
                          />
                          <br></br>
                          {/* <Header as="h3">{idioma}</Header> */}
                          <Box sx={{ minWidth: 120 }}>
                            <FormControl fullWidth>
                              <NativeSelect
                                value={formik.values.idioma}
                                size="small"
                                inputProps={{
                                  name: "idioma",
                                  id: "idioma",
                                }}
                                onChange={(event) => {
                                  formik.setFieldValue(
                                    "idioma",
                                    event.target.value
                                  );
                                  setIdioma(event.target.value);
                                }}
                                error={formik.errors.idioma}
                              >
                                {/* {idiomaRegistros.map((opcion) => (
                                  <option
                                    key={opcion.value}
                                    value={opcion.value}
                                  >
                                    &nbsp; {opcion.text}
                                  </option>
                                ))} */}

                                <option key="English" value="English">
                                  English
                                </option>
                                <option key="Español" value="Español">
                                  Español
                                </option>
                                <option key="Português" value="Português">
                                  Português
                                </option>
                              </NativeSelect>
                            </FormControl>
                          </Box>
                          {/* <Header as="h3">{localidad}</Header> */}
                          <Box sx={{ minWidth: 120 }}>
                            <FormControl fullWidth>
                              <NativeSelect
                                value={formik.values.localidad}
                                size="small"
                                inputProps={{
                                  name: "localidad",
                                  id: "localidad",
                                }}
                                onChange={(event) => {
                                  formik.setFieldValue(
                                    "localidad",
                                    event.target.value
                                  );
                                  setLocalidad(event.target.value);
                                }}
                                error={formik.errors.localidad}
                              >
                                {/* {localidadRegistros.map((opcion) => (
                                  <option
                                    key={opcion.value}
                                    value={opcion.value}
                                  >
                                    &nbsp; {opcion.text}
                                  </option>
                                ))} */}

                                <option key="El Calafate" value="El Calafate">
                                  El Calafate
                                </option>
                                <option key="Valencia" value="Valencia">
                                  Valencia
                                </option>
                                <option key="Córdoba" value="Córdoba">
                                  Córdoba
                                </option>
                                <option key="Ushuaia" value="Ushuaia">
                                  Ushuaia
                                </option>
                                <option
                                  key="Santiago del Estero"
                                  value="Santiago del Estero"
                                >
                                  Santiago del Estero
                                </option>
                                <option
                                  key="Colonia Caroya"
                                  value="Colonia Caroya"
                                >
                                  Colonia Caroya
                                </option>
                              </NativeSelect>
                            </FormControl>
                          </Box>
                          <br></br>
                          {/* <Header as="h3">{contacto}</Header> */}
                          <TextField
                            id="email"
                            label={email}
                            placeholder={email}
                            disabled
                            variant="standard"
                            name="email"
                            type="text"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.email &&
                              Boolean(formik.errors.email)
                            }
                            helperText={
                              formik.touched.email && formik.errors.email
                            }
                            size="small"
                          />
                          {/* <Header as="h3">{telefono}</Header> */}
                          <TextField
                            id="telefono"
                            label={telefono}
                            placeholder={telefono}
                            variant="standard"
                            name="telefono"
                            type="text"
                            value={formik.values.telefono}
                            onChange={formik.handleChange}
                            error={
                              formik.touched.telefono &&
                              Boolean(formik.errors.telefono)
                            }
                            helperText={
                              formik.touched.telefono && formik.errors.telefono
                            }
                            size="small"
                          />
                          {/* <Header as="h3">{banco}</Header> */}
                          <TextField
                            id="nombreBanco"
                            label={nombre_Banco}
                            placeholder={nombre_Banco}
                            variant="standard"
                            name="nombreBanco"
                            type="text"
                            value={formik.values.nombreBanco}
                            onChange={formik.handleChange}
                            helperText={
                              formik.touched.nombreBanco &&
                              formik.errors.nombreBanco
                            }
                            size="small"
                          />
                          <TextField
                            id="titular"
                            label={titular}
                            placeholder={titular}
                            variant="standard"
                            name="titular"
                            type="text"
                            value={formik.values.titular}
                            onChange={formik.handleChange}
                            helperText={
                              formik.touched.titular && formik.errors.titular
                            }
                            size="small"
                          />
                          <TextField
                            id="CBU"
                            label="CBU"
                            placeholder="CBU"
                            variant="standard"
                            name="CBU"
                            type="text"
                            value={formik.values.CBU}
                            onChange={formik.handleChange}
                            helperText={formik.touched.CBU && formik.errors.CBU}
                            size="small"
                          />
                          <div style={{ color: "gainsboro" }}>
                            <small>
                              <b>UserId</b>
                            </small>
                            <br></br>
                            <small>{getid()}</small>
                            <br></br>
                            <small>
                              <b>OS</b>
                            </small>
                            <br></br>
                            <small>{SistemaOperativo}</small>
                          </div>
                        </Box>
                      </Grid.Column>
                    </Grid.Row>
                  </div>
                </Grid>
              </Segment>
            </Box>
          </Container>
          <ScrollTop {...props}>
            <Fab size="small" aria-label="scroll back to top">
              <KeyboardArrowUpIcon />
            </Fab>
          </ScrollTop>
        </React.Fragment>
      </form>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={handleClose}
      >
        <Player
          src={animacion}
          className="player"
          loop
          autoplay
          style={{ height: 110 }}
        />
      </Backdrop>
    </div>
  );
}
